import './GoldenRecordPage.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {
    Box,
    Skeleton,
} from "@mui/material";
import {useStores} from "../../stores";
import {GoldenRecordTableComponent} from "./components/GoldenRecordTableComponent";
import {MainPageFacade} from "../../components/main/page/MainPageFacade.tsx";
import {GoldenRecordClusterMenu} from "./components/Menu/GoldenRecordClusterMenu.tsx";
import {CustomBreadcrumbs} from "../../components/CustomBreadcrumbs/CustomBreadcrumbs.tsx";
import {GroupingSettingsModal} from "./components/GroupingSettingModal/GroupingSettingsModal.tsx";

export const GoldenRecordPage: React.FC = observer(() => {
    const {authStore, goldenRecordStore} = useStores();
    const filterController = goldenRecordStore.grPageController.filterController;
    const [isClusterMenuCollapsed, setIsClusterMenuCollapsed] = React.useState(false);

    React.useEffect(() => {
        if (filterController.clusters.length > 0)
            filterController.setClustersPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authStore.isMithraStaffGroup]);

    return (
        <Box className="golden-record-page-content">
            <GoldenRecordClusterMenu
                collapsed={isClusterMenuCollapsed}
                onToggleCollapsed={() => setIsClusterMenuCollapsed((c) => !c)}
            />
            <Box className="goldern-record-main-box">
                <MainPageFacade
                    title={
                        <CustomBreadcrumbs
                            loading={filterController.isFetchingForTheFirstTime}
                            contents={[
                                "Material Harmonization",
                                filterController.selected_cluster_harmonized_name
                                    ? filterController.selected_cluster_harmonized_name.replace(
                                        /\b\w/g,
                                        (c) => c.toUpperCase(),
                                    )
                                    : "loading",
                            ]}
                        ></CustomBreadcrumbs>
                    }
                    className="golden-record-page"
                    actionBarEnd={
                        filterController.isFetchingForTheFirstTime ? (
                            <Skeleton width={205} height={36}/>
                        ) : (
                            <GroupingSettingsModal/>
                        )
                    }
                >
                    {filterController.isFetchingForTheFirstTime ? (
                        <Skeleton
                            sx={{
                                marginTop: "16px",
                                height: "calc(100vh - 64px - 24px - 16px - 24px)",
                            }}
                        />
                    ) : (
                        <GoldenRecordTableComponent isClusterMenuCollapsed={isClusterMenuCollapsed}/>
                    )}
                </MainPageFacade>
            </Box>
        </Box>
    );
});
